export default "__VITE_ASSET__BRuOPuhe__"